<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
};
</script>

<style lang="less">
@base-color: #26a9b0;
@font-size-small: 0.24rem;
@font-size-medium: 0.32rem;
@font-face {
  font-family: 'MeituanType-Regular';
  src: url('./assets/font/MeituanTypeRegular.ttf') format('truetype');
}
html {
  font-size: 14px !important;
  min-width: 1440px;
}
body {
  width: 100% !important;
  min-width: 1440px;
  overflow-y:auto;
}
#app {
  font-family: 'PingFangSC-Regular';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1440px;
  overflow-y:auto;
}
</style>
